import { takeLatest } from 'redux-saga/effects';
import {
  getSalaryAdditionListSuccess, getSalaryAdditionListFail,
  getSalaryAdditionDetailsSuccess, getSalaryAdditionDetailsFail
} from './salaryAdditionState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/finance/salary-additions');
const redirectData = {route:'/console/salary-additions', mode: 'list', recordId:0 };
const modelName = 'Salary Addition';
const modelId = 'sdn_id';

function* getSalaryAdditionList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getSalaryAdditionListSuccess, 
		getSalaryAdditionListFail,
		null, null, LOADING_MSG);
}

function* getSalaryAdditionDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getSalaryAdditionDetailsSuccess, 
		getSalaryAdditionDetailsFail,
		null, null, LOADING_MSG);		
}

function* doSalaryAdditionCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getSalaryAdditionDetailsSuccess, 
		getSalaryAdditionDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doSalaryAdditionUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getSalaryAdditionDetailsSuccess, 
		getSalaryAdditionDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doSalaryAdditionDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getSalaryAdditionDetailsSuccess, 
		getSalaryAdditionDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* salaryAdditionSaga() {
  yield takeLatest('salaryAddition/getSalaryAdditionList', getSalaryAdditionList);
  yield takeLatest('salaryAddition/getSalaryAdditionDetails', getSalaryAdditionDetails);
  yield takeLatest('salaryAddition/doSalaryAdditionCreate', doSalaryAdditionCreate);
  yield takeLatest('salaryAddition/doSalaryAdditionUpdate', doSalaryAdditionUpdate);
  yield takeLatest('salaryAddition/doSalaryAdditionDelete', doSalaryAdditionDelete);  
}

export default salaryAdditionSaga;
